// Typelizer digest f04832e738ebc0c1bb3110f012ca341b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/ledger/manual_journals/:manual_journal_id/posting */
  create: (
    params: { manualJournalId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/ledger/manual_journals/:manual_journal_id/posting', params, options),
    method: 'post',
  }),
}
